import { MinusBoxMultipleIcon } from './MinusBoxMultipleIcon';

/**
 * author: Michael Irigoyen
 * id 8B150753-A2AC-4750-B6EC-686D213805DE
 * name minus-box-multiple
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/minus-box-multiple.svg
 * tags
 * - Form 
 */
export const LibraryMinusIcon = MinusBoxMultipleIcon;
export default LibraryMinusIcon